import React, { useState, useEffect, useCallback } from "react";
import { publish } from "pubsub-js";
import { css } from "emotion";
import { withRouter } from "react-router";
import eventType from "../../events/eventType";
import { Panel, PanelHeader, PanelContent, PanelFooter } from "../../../shared/create-offer/Panel";
import Button from "../../../shared/button/button";
import OfferMiles from "../../components/new-offer/step3-offerMiles";
import RegistrationCreditCard from "../../components/new-offer/step4-registrationCreditCard";
import FinishedOffer from "../../components/new-offer/step5-finishedOffer";
import { useNewOffer } from "../../context/new-offer";
import BoxTotalExpectedGain from "../../../shared/create-offer/BoxTotalExpectedGain/BoxTotalExpectedGain";
import EditOfferHeader from "../../../shared/create-offer/EditOfferHeader/EditOfferHeader";
import {
	ROUTE_HOME,
	ROUTE_PREFIX_EDIT_OFFER,
	prefixOfferMiles,
	prefixCreditCard,
	prefixFinished,
	prefixValidateOffer,
	prefixFinishedError,
	prefixFidelityAndBank
} from "../../shared/constants";
import {
	EditarOfertaModal,
	OfertaEmVendaModal,
	VinduloPendenteModal,
	VendaRapidaNaoElegivel,
	AvisoProblemaModal,
	AvisoProblemaModalPagamentoAntecipado,
	PagamentoAntecipadoNaoElegivel
} from "../../services/modals";
import Loading from "../../../shared/create-offer/Loading/Loading";
import { loadingStyle } from "./style";
import RegistrationData from "./step2-registrationData";
import { handleFidelityNameToPath, uuid } from "../../shared/utils";
import ResultOffer from "./step6-resultOffer";
import { GOL_ACRONYM, GOL_FIDELITY_PROGRAM, Type2FA } from "../../../../js/shared/constants";
import ModalProcessingTwoFactorAuthentication from "../../../shared/create-offer/ModalProcessingTwoFactorAuthentication/ModalProcessingTwoFactorAuthentication";
import ModalErrorTwoFactorAuthentication from "../../../shared/create-offer/ModalErrorTwoFactorAuthentication/ModalErrorTwoFactorAuthentication";
import Await2FAModal from "../../../shared/create-offer/Await2FAModal/Await2FAModal";

const NewOfferEdit = ({ match, history }) => {
	const {
		currentProgram,
		userData,
		newOfferTempData,
		offerData,
		pricesData,
		selectOfferToEdit,
		editOffer,
		creditCardData,
		quickSaleProblem,
		setQuickSaleProblem,
		postData,
		forceStep,
		setForceStep,
		participantData,
		acceptanceTerms,
		forwardPaymentProblem,
		setForwardPaymentProblem,
		loyaltyData,
		email2FAStatusValidation,
		showModalErrorTwoFactorAuthentication,
		setShowModalErrorTwoFactorAuthentication,
		twoFactorData,
		send2FACode,
		setUuidCybersource,
		uuidCybersource,
		hasClickedRequest2FACode,
		setHasTriedToProceedWithout2FA
	} = useNewOffer();
	const typePhoneLatam = loyaltyData.data.phoneRequiredMode;
	const [index, setIndex] = useState(0);
	const [oldQuantMiles, setOldQuantMiles] = useState(0);
	const [modals, setModals] = useState({
		ofertaEmVenda: false,
		ofertaNaoAprovada: false,
		editarOferta: false,
		vinculoPendente: false,
		avisoProblemaModal: false,
		avisoProblemaModalPagamentoAntecipado: false,
		twoFactor: false
	});
	const [showCreditCard] = useState(
		!creditCardData.hasCreditCard &&
			currentProgram &&
			currentProgram.international === "1" &&
			(currentProgram.id == 25 ||
				currentProgram.id == 11 ||
				currentProgram.id == 10 ||
				currentProgram.id == 14)
	);

	const isQuickSale = editOffer && editOffer.quickSale;

	const isForwardPayment = editOffer && editOffer.forwardPayment;

	const closeTwoFactorModal = () => {
		setModals({ ...modals, twoFactor: false });
		nextStep(undefined, true);
	};

	const handleTwoFactorModalConfirm = () => {
		send2FACode();
		closeTwoFactorModal();
	};

	const handleTwoFactorModalCancel = () => {
		closeTwoFactorModal();
	};

	useEffect(() => {
		return () => {
			selectOfferToEdit({}); // Limpa edição
		};
	}, []);

	useEffect(() => {
		if (forceStep === 3) {
			setForceStep(undefined);
		}
	}, [forceStep]);

	useEffect(() => {
		const { quant } = offerData?.data;

		if (!oldQuantMiles) {
			setOldQuantMiles(quant);
		}
	}, [offerData, oldQuantMiles]);

	useEffect(() => {
		setModals({
			...modals,
			ofertaEmVenda: editOffer.status === 3,
			ofertaNaoAprovada: editOffer.status !== 3 && editOffer.editable === false,
			vendaRapidaNaoElegivel: quickSaleProblem,
			vinculoPendente: participantData.isDone && participantData.hasRelationshipPendent,
			avisoProblemaModal: editOffer.editable == false,
			pagamentoAntecipadoNaoElegivel: forwardPaymentProblem,
			avisoProblemaModalPagamentoAntecipado:
				editOffer.editable == false && editOffer.type == 4 && editOffer.status !== 4
		});
	}, [editOffer, quickSaleProblem, participantData, forwardPaymentProblem]);

	const divLoading = (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<Loading width={120} height={120} />
		</div>
	);

	const buildPath = prefix => {
		return `${prefix}/${handleFidelityNameToPath(currentProgram)}`;
	};

	const steps = [
		{
			path: buildPath(prefixValidateOffer),
			component: () => <FinishedOffer history={history} />
		}
	];

	if (!isQuickSale && !isForwardPayment) {
		steps.splice(0, 0, {
			path: buildPath(prefixOfferMiles),
			component: () =>
				forceStep !== undefined ||
				modals.vendaRapidaNaoElegivel ||
				modals.pagamentoAntecipadoNaoElegivel ? (
					divLoading
				) : (
					<OfferMiles typePhoneLatam={typePhoneLatam} />
				)
		});
	} else {
		steps.splice(0, 0, {
			path: buildPath(prefixFidelityAndBank),
			component: () => (
				<RegistrationData
					typePhoneLatam={typePhoneLatam}
					loading={userData.isFetching}
					fidelityProgram={currentProgram}
				/>
			)
		});
	}

	if (showCreditCard) {
		steps.splice(steps.length - 1, 0, {
			path: buildPath(prefixCreditCard),
			component: () => <RegistrationCreditCard />
		});
	}

	const matchPath = `${match.params.path}/${match.params.step}`;
	const matchIndex = steps.findIndex(step => step.path === matchPath);

	const currentStep = steps[index] || {
		path: buildPath(prefixFinished),
		component: () => <ResultOffer typePhoneLatam={typePhoneLatam} />
	};

	useEffect(() => {
		if (matchIndex > index) {
			history.push(`${ROUTE_PREFIX_EDIT_OFFER}/${currentStep.path}`);
		} else if (steps[matchIndex]) {
			setIndex(matchIndex);
		} else if (
			match.params.path &&
			(match.params.path.includes(prefixFinished) ||
				match.params.path.includes(prefixFinishedError))
		) {
			setIndex(steps.length);
		}
	}, [match, history, matchIndex]);

	useEffect(() => {
		window.scrollTo(0, 0);
		if (!currentProgram.id) {
			history.push(ROUTE_HOME);
		} else if (currentStep.path && !currentStep.path.includes(prefixFinished)) {
			history.push(`${ROUTE_PREFIX_EDIT_OFFER}/${currentStep.path}`);
		}
	}, [index]);

	// Controla os steps
	const nextStep = useCallback(
		(ev, ignoreModal = false) => {
			const { fidelityName, international } = currentProgram;
			const { quant: actualQuantMiles, price: priceMiles, averageMiles } = offerData?.data;
			const { path: step } = currentStep;
			const { paymentDeadline } = editOffer;
			const { twoFactorAuthenticationStrategy } = loyaltyData.data;

			let newIndex = index + 1;

			if (index === steps.length - 2 && twoFactorData.is2FAEnabled && !hasClickedRequest2FACode) {
				setHasTriedToProceedWithout2FA(true);
				return;
			}

			if (!ignoreModal && twoFactorData.is2FAEnabled && index === steps.length - 2) {
				setModals({ ...modals, twoFactor: true });
				return;
			}

			if (
				!ignoreModal &&
				((currentStep.path.includes(prefixOfferMiles) && international === "0") ||
					isQuickSale ||
					isForwardPayment)
			) {
				// Saindo da tela de oferta de milhas (ignorar venda rapida, ignorar pagamento antecipado) | é uma edição | nacional apenas
				setModals({
					...modals,
					editarOferta: true
				});
				return;
			}

			publish(eventType.OFFER_EDIT, {
				fidelityName,
				oldQuantMiles,
				actualQuantMiles,
				priceMiles,
				step: `edicao-${step.split("/")[0]}`,
				averageMiles,
				paymentDeadline,
				twoFactorAuthenticationStrategy
			});

			if (newIndex === steps.length - 1) {
				if (
					currentProgram.id === GOL_FIDELITY_PROGRAM &&
					loyaltyData.data.twoFactorAuthenticationStrategy === Type2FA.EMAIL_REDIRECT &&
					!email2FAStatusValidation.isValidated
				) {
					newIndex = newIndex - 1;
				}
				postData();
			}

			setIndex(newIndex);
		},
		[
			offerData,
			pricesData,
			currentProgram,
			editOffer,
			currentStep,
			steps,
			isQuickSale,
			isForwardPayment,
			prefixOfferMiles,
			loyaltyData
		]
	);

	const prevStep = () => {
		if (index > 0) {
			setIndex(index - 1);
		} else {
			selectOfferToEdit({}); // Limpa edição
			history.push(ROUTE_HOME);
		}
	};

	const checkNextDisabled = () => {
		const hasInvalidOfferData = offerData?.data?.invalid;
		const isFetchingData = offerData.isFetching || pricesData.isFetching || userData.isFetching;
		const phone = loyaltyData?.data?.phone ?? "";
			
		if (hasInvalidOfferData || isFetchingData) {
			return true;
		} else if (
			(!newOfferTempData.form.completedBoxDataBankDetails &&
				!participantData.hasManagementActive) ||
			!loyaltyData?.data?.password ||
			loyaltyData?.data?.password?.length < 3 ||
			(typePhoneLatam === 0 &&
				phone?.length !== 11 &&
				!newOfferTempData.form.completedBoxDataFidelityProgramDetails) ||
			(typePhoneLatam === 2 && phone?.length !== 11) ||
			(phone &&
				phone?.length !== 11 &&
				phone?.length !== 0 &&
				typePhoneLatam !== 0 &&
				loyaltyData?.data?.id === 3) ||
			(phone &&
				phone[2] !== "9" &&
				loyaltyData?.data?.id === 3) ||
			!acceptanceTerms ||
			(!loyaltyData?.data?.user && loyaltyData?.data?.id !== 3)
		) {	
			return true;
		} else if (
			currentStep.path.includes(prefixOfferMiles) &&
			!newOfferTempData.form.completedBoxOfferMiles
		) {	
			return true;
		} else if (
			currentStep.path.includes(prefixCreditCard) &&
			!newOfferTempData.form.completedBoxCreditCardDetails
		) {	
			return true;
		}
		return false;
	};

	const editarOfertaConfirm = ev => {
		setModals({
			...modals,
			editarOferta: false
		});
		nextStep(ev, true);
	};

	const editarOfertaCancel = () => {
		setModals({
			...modals,
			editarOferta: false
		});
	};

	useEffect(() => {
		if (email2FAStatusValidation.isValidated) {
			setIndex(prevIndex => prevIndex + 1);
		}
	}, [email2FAStatusValidation]);

	useEffect(() => {
		if (email2FAStatusValidation.isValidated) {
			setIndex(prevIndex => prevIndex + 1);
		}
	}, [email2FAStatusValidation]);

	useEffect(() => {
		if (uuidCybersource) return;
		setUuidCybersource(uuid());
	}, [uuidCybersource]);

	return (
		<div className="new-offers">
			<Panel overflow={false}>
				{index <= steps.length - 2 ? (
					<PanelHeader className="flex-column">
						<EditOfferHeader />
					</PanelHeader>
				) : (
					<></>
				)}
				<PanelContent>{currentStep.component()}</PanelContent>
				{index <= steps.length - 2 ? (
					<PanelFooter className="new-offers--panel-footer">
						{isQuickSale || isForwardPayment ? (
							<br />
						) : (
							<Button
								className={"btn-gray-lg-o"}
								onClick={() => prevStep()}
								data-action="steps-prev"
							>
								Voltar
							</Button>
						)}
						{currentStep.path.includes(prefixOfferMiles) && <BoxTotalExpectedGain />}
						<Button
							disabled={checkNextDisabled()}
							onClick={() => nextStep()}
							className={"btn-primary-lg"}
							data-action="steps-next"
						>
							{index === steps.length - 2 ? "Concluir" : "Próximo"}
						</Button>
					</PanelFooter>
				) : (
					<></>
				)}
			</Panel>
			<VendaRapidaNaoElegivel
				show={modals.vendaRapidaNaoElegivel}
				onConfirm={() => {
					setQuickSaleProblem(false);
					editOffer.quickSale = undefined;
					setModals({ ...modals, vendaRapidaNaoElegivel: false });
				}}
			/>
			<PagamentoAntecipadoNaoElegivel
				show={modals.pagamentoAntecipadoNaoElegivel}
				onConfirm={() => {
					setForwardPaymentProblem(false);
					editOffer.forwardPayment = undefined;
					editOffer.paymentDeadline = undefined;
					setModals({ ...modals, pagamentoAntecipadoNaoElegivel: false });
				}}
			/>
			<OfertaEmVendaModal
				show={modals.ofertaEmVenda}
				onConfirm={() => {
					selectOfferToEdit({}); // Limpar oferta
					history.push(ROUTE_HOME);
				}}
			/>
			<EditarOfertaModal
				isQuickSale={isQuickSale}
				isForwardPayment={isForwardPayment}
				show={modals.editarOferta}
				onConfirm={editarOfertaConfirm}
				onCancel={editarOfertaCancel}
			/>
			<VinduloPendenteModal
				show={modals.vinculoPendente}
				onConfirm={() => {
					setModals({ ...modals, vinculoPendente: false });
					history.push(ROUTE_HOME);
				}}
			/>
			<AvisoProblemaModal
				show={modals.avisoProblemaModal}
				onConfirm={() => {
					setModals({ ...modals, avisoProblemaModal: false });
					history.push(ROUTE_HOME);
				}}
			/>
			<AvisoProblemaModalPagamentoAntecipado
				show={modals.avisoProblemaModalPagamentoAntecipado}
				onConfirm={() => {
					setModals({ ...modals, avisoProblemaModalPagamentoAntecipado: false });
					history.push(ROUTE_HOME);
				}}
			/>
			<ModalErrorTwoFactorAuthentication
				show={showModalErrorTwoFactorAuthentication}
				onConfirm={() => setShowModalErrorTwoFactorAuthentication(false)}
			/>
			<ModalProcessingTwoFactorAuthentication show={email2FAStatusValidation.isFetching} />

			<Await2FAModal
				show={modals.twoFactor}
				onConfirm={handleTwoFactorModalConfirm}
				onCancel={handleTwoFactorModalCancel}
			/>
		</div>
	);
};

export default withRouter(NewOfferEdit);
